import { IdentityApiSdk } from "@packsize/identity-api-sdk";
import { createContext } from "react";

export interface IdentityClientContextProps {
	client: IdentityApiSdk;
	createClient: (token: string) => IdentityApiSdk;
}

export const IdentityClientContext = createContext<IdentityClientContextProps>({
	client: new IdentityApiSdk(),
	createClient: () => new IdentityApiSdk(),
});
